import React, { useEffect } from "react";

function H5ADMetadataViewer({ handle, metadata, status }) {
  useEffect(() => {
    console.log(`🧬 [H5ADMetadataViewer] Mount for "${handle}"`);
    console.time(`⏱️ Metadata render for "${handle}"`);
    return () => {
      console.log(`🧪 [H5ADMetadataViewer] Unmount for "${handle}"`);
      console.timeEnd(`⏱️ Metadata render for "${handle}"`);
    };
  }, [handle]);

  useEffect(() => {
    if (metadata) {
      const sizeKB = JSON.stringify(metadata).length / 1024;
      console.log(`📦 [H5ADMetadataViewer] Metadata size: ${sizeKB.toFixed(2)} KB`);
    }
  }, [metadata]);

  const statusMessages = {
    requesting: "🌐 Requesting metadata...",
    saving: "💾 Saving metadata...",
    loading: "🔄 Loading metadata...",
    idle: null,
  };

  return (
    <div className="bg-white p-4 mt-6 rounded shadow-md">
      <h2 className="text-lg font-semibold mb-2">📊 Metadata & Stats</h2>
      {status !== "idle" || !metadata ? (
        <div className="text-gray-600 italic">{statusMessages[status] || "⏳ Processing metadata..."}</div>
      ) : (
        <pre className="text-sm overflow-auto bg-gray-100 p-2 rounded">
          {/* {JSON.stringify({ metadata }, null, 2)} */}
        </pre>
      )}
    </div>
  );
}

export default H5ADMetadataViewer;
